import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-canonical',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Canonical icon</title><path d="M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C0 5.372 5.372 0 12 0c6.627 0 12 5.372 12 12zM12 2.92A9.08 9.08 0 002.92 12 9.08 9.08 0 0012 21.08 9.08 9.08 0 0021.081 12 9.08 9.08 0 0012 2.92zm0 16.722A7.64 7.64 0 014.36 12 7.64 7.64 0 0112 4.36 7.64 7.64 0 0119.641 12a7.64 7.64 0 01-7.64 7.641z"/></svg>`,
    styles: []
})
export class SimpleIconsCanonicalComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#77216F';
    @Input() className: string = 'simple-icons-canonical'
    constructor() {}
    ngOnInit(): void {}
}
